const langButton = document.querySelector('.lang-menu__button')
if (langButton) {
  const langList = document.querySelector('.lang-menu__list')
  const arrowElementButton = document.querySelector('.lang-menu__arrow')
  langButton.addEventListener('click', () => {
    if (langList) {
      langButton.classList.toggle('lang-menu__button_open')
      langList.classList.toggle('lang-menu__list_open')
      arrowElementButton.classList.toggle('lang-menu__arrow_rotate')
    }
  })
}

const menuButtonBurger = document.querySelector('.header__btn-burger')
if (menuButtonBurger) {
  const menuButtonClose = document.querySelector('.header__btn-close')
  const menu = document.querySelector('.header__items')

  function toggleMobileMenu() {
    menu.classList.toggle('header__items_open')
    menuButtonBurger.classList.toggle('header__btn-burger_disable')
    menuButtonClose.classList.toggle('header__btn-close_enable')
  }

  menuButtonBurger.addEventListener('click', () => {
    toggleMobileMenu()
  })

  menuButtonClose.addEventListener('click', () => {
    console.log('click')
    toggleMobileMenu()
  })
}

// timeout is needed to connect listeners after rendering the vue
setTimeout(() => {
  const faqItems = document.querySelectorAll('.faq__item');

  const closeItemFaq = (indexParent) => {
    document.querySelectorAll('.faq__item-answer').forEach((i, indexChildren) => {
      if (indexChildren !== indexParent) {
        i.style.maxHeight = 0;
        faqItems[indexChildren].classList.remove('faq__item_open');
      }
    });
  }

  if (faqItems) {
    faqItems.forEach((i, indexParent) => {
      i.addEventListener('click', () => {
        closeItemFaq(indexParent);
        const item = i.querySelector('.faq__item-answer');
        if (getComputedStyle(item).maxHeight === '0px') {
          item.style.maxHeight = item.scrollHeight + 'px';
          i.classList.add('faq__item_open');
        } else {
          item.style.maxHeight = 0;
          i.classList.remove('faq__item_open');
        }
      })
    });
  }
}, 500);
